<template>
    <div class="chapter" :class="[{'chapter--opened': opened},'chapter'+number]">
        <div class="chapter__top">
            <div class="table-of-contents table-of-contents--desktop">
                <svg @click="changeRoute(-1)" class="table-of-contents__arrow" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 110.2 26" style="enable-background:new 0 0 110.2 26;" xml:space="preserve">
                    <path d="M45.7,21.1c-5.3-2-10.5-3.9-15.8-5.9c25.4-0.6,50.8-1.2,76.2-1.8c1.2,0,0.8-4.4-0.6-4.4 C78,9.6,50.4,10.3,22.9,10.9c5.5-1.9,11-3.8,16.5-5.7c1.4-0.5,0.5-4.8-0.6-4.4L7,11.3c-1,0.3-0.9,3.1,0,4.1C7.1,15.7,7.3,16,7.6,16"></path>
                </svg>
                <a @click="setRoute($index + 1)" class="table-of-contents__item" :class="{'table-of-contents__item--active': $index === number - 1}" :key="$index" v-for="(chapter, $index) in chapters">{{chapter}}</a>
                <svg :style="{opacity: number < chapters.length  ? 1 : 0}" @click="changeRoute(1)"  class="table-of-contents__arrow" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 110.2 26" style="enable-background:new 0 0 110.2 26;" xml:space="preserve">
                   <path d="M68.1,5.3c5.2,2.1,10.4,4.2,15.6,6.2c-25.4,0-50.8,0-76.2,0c-1.2,0-0.9,4.4,0.5,4.4c27.6,0.1,55.1,0.1,82.7,0 c-5.6,1.8-11.1,3.5-16.7,5.3c-1.4,0.4-0.6,4.8,0.5,4.4l32-9.7c1.1-0.3,1-3.1,0.1-4.1c-0.2-0.3-0.4-0.6-0.6-0.6 c-12.7-3.4-25.3-6.8-38-10.2C66.7,0.6,67,4.8,68.1,5.3"/>
                </svg>
            </div>

            <div class="table-of-contents table-of-contents--mobile">
                <a @click="changeRoute(-1)" class="table-of-contents__item">
                    <svg class="table-of-contents__arrow" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 110.2 26" style="enable-background:new 0 0 110.2 26;" xml:space="preserve">
                        <path d="M45.7,21.1c-5.3-2-10.5-3.9-15.8-5.9c25.4-0.6,50.8-1.2,76.2-1.8c1.2,0,0.8-4.4-0.6-4.4 C78,9.6,50.4,10.3,22.9,10.9c5.5-1.9,11-3.8,16.5-5.7c1.4-0.5,0.5-4.8-0.6-4.4L7,11.3c-1,0.3-0.9,3.1,0,4.1C7.1,15.7,7.3,16,7.6,16"></path>
                    </svg>
                    <span v-if="number > 1" class="table-of-contents__item__text">{{chapters[number - 2]}}</span>
                </a>
                <div class="table-of-contents__item table-of-contents__item--current">
                    {{chapters[number - 1]}}
                </div>
                <a @click="changeRoute(1)" class="table-of-contents__item">
                    <span class="table-of-contents__item__text">{{chapters[number]}}</span>
                    <svg :style="{opacity: number < chapters.length  ? 1 : 0}" class="table-of-contents__arrow" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 110.2 26" style="enable-background:new 0 0 110.2 26;" xml:space="preserve">
                       <path d="M68.1,5.3c5.2,2.1,10.4,4.2,15.6,6.2c-25.4,0-50.8,0-76.2,0c-1.2,0-0.9,4.4,0.5,4.4c27.6,0.1,55.1,0.1,82.7,0 c-5.6,1.8-11.1,3.5-16.7,5.3c-1.4,0.4-0.6,4.8,0.5,4.4l32-9.7c1.1-0.3,1-3.1,0.1-4.1c-0.2-0.3-0.4-0.6-0.6-0.6 c-12.7-3.4-25.3-6.8-38-10.2C66.7,0.6,67,4.8,68.1,5.3"/>
                    </svg>
                </a>
            </div>

            <div class="chapter__illustration" :style="{backgroundImage: `url(${require(`../assets/illustrations/${illustration}`)})`}"></div>
            <div class="chapter__content">
                <slot name="header_texts"></slot>
            </div>

        </div>
        <slot name="main" ></slot>
    </div>
</template>
<script>
    export default {
        methods: {
            setRoute(number) {
                this.$router.push(`/chapters/${number}`);
                this.$ga.event('internal','click', 'topmenu_chapter_'+(number));
            },
            changeRoute(i) {
                if (this.number + i > 0 && this.number + i <= this.chapters.length) {
                    let number = this.number + i;
                    this.$router.push(`/chapters/${number}`);
                } else {
                    if (this.number === 1 && i === -1) {
                        this.$router.push('/');
                    }
                }
                this.$ga.event('internal','click', (i> 0)? 'topmenu_chapter_forward': 'topmenu_chapter_back');
            }
        },
        data() {
            return {
                chapters: [
                    'I',
                    'II',
                    'III',
                    'IV',
                    'V',
                    'VI',
                    'VII',
                    'VIII',
                ]
            }
        },
        props: {
            opened: {
                type: Boolean,
                required: false
            },
            illustration: {
                type: String,
                required: true
            },
            number: {
                type: Number,
                required: true
            }
        }
    }
</script>
<style lang="stylus">
    @import "~@/assets/styles/sizes.styl";

    .chapter
        background #f0f0f0
        min-height 100%
        &__top
            +mobile()
                height auto
        +mobile()
            /*
            height 100vh
            overflow hidden
            */
        &--opened
            +mobile()
                overflow visible
                height auto

        &__author
            padding-top vw(16, $desktop)
            color #d1c4ac
            font-style italic
            font-size vw(14, $desktop)
            z-index 103
            +mobile()
                font-size vw(15, $mobile)!important
                padding-top vw(40, $mobile)
                position relative
                margin vw(-10, $mobile) 0
                height auto
        &__illustration
            position absolute
            top 0
            left 0
            width 100%
            height 100%
            background-size cover!important
            background-position right center
            background-repeat no-repeat
            +mobile()
                top vw(-18, $mobile)
                background-position right bottom
                background-size 150vw!important
                filter brightness(.975) contrast(1.1)
                height "calc(100% - %s)" % vw(60, $mobile)
        &__illustration
            +mobile()
                display none
        &__mobile-illustration
            +mobile()
                margin 0 vw(-20, $mobile)
                position relative
                z-index 103
                width "calc(100% + %s)" % vw(40, $mobile)
                height vw(240, $mobile)
                background-size cover!important
                background-position right center
                background-repeat no-repeat
                &:before
                    content ""
                    display block
                    position absolute
                    top 0
                    left 0
                    width 100%
                    height 25%
                    background linear-gradient(#edecec 25%, rgba(240, 240, 240, 0))
                &:after
                    content ""
                    display block
                    position absolute
                    bottom 0
                    left 0
                    width 100%
                    height 25%
                    background linear-gradient(rgba(240, 240, 240, 0) 25%, #edecec)
        &__illustration:before
            content ""
            display none
            position absolute
            top 0
            left 0
            width 180%
            height 100%
            background radial-gradient(rgba(240, 240, 240, 0) 25%,#f0f0f0 75%)
            +mobile()
                display block
                height 100%
                top 0
                bottom .75em
                background linear-gradient(#ececeb 30%, rgba(240,240,240,0) 50%)
        &--opened &__illustration:before
            display block
        &__illustration:after
            background linear-gradient(rgba(240, 240, 240, 0), #f0f0f0)
            content ""
            display none
            position absolute
            top 70%
            left 0
            width 100%
            height 30%
            +mobile()
                display none!important
        &--opened &__illustration:before, &--opened &__illustration:after
            display block
        &--opened &__illustration:before
            +mobile()
                background linear-gradient(#ececeb 50%, rgba(240,240,240,0) 100%)
            display block
        &--header-right &__illustration:before
            left -80%
        &__illustration:before, &__illustration:after
            /*
            +mobile()
                display block
                */
        &__illustration:after
            +mobile()
                top 55%
                height 30%
                background linear-gradient(#f0f0f0, rgba(240, 240, 240, 0))
        &__content
            position relative
            z-index 101
            height 100vh
            display flex
            align-items center
            padding-left vw(36, $desktop)
            text-align center
            max-width vw(480, $desktop)
            top vw(-34, $desktop)
            +mobile()
                height auto
                position initial
                align-items flex-start
                max-width "calc(100% - %s)" % vw(40, $mobile)
                padding-left vw(20, $mobile)
                padding-right vw(20, $mobile)
                flex-direction column
        &--opened &__content
            height auto
            padding-top vw(140, $desktop)
            +mobile()
                padding-top 0
        &--header-right &__content
            margin-left auto
            padding-left 0
            padding-right vw(18, $desktop)
            +mobile()
                padding-left vw(20, $mobile)
                padding-right vw(20, $mobile)
        &__number
            font-family Baskerville
            color #cb993f
            font-size vw(40, $desktop)
            margin-bottom vw(5, $desktop)
            +mobile()
                display none
                font-size vw(36, $mobile)
        &__headline
            font-family Solena
            font-size vw(74, $desktop)
            white-space nowrap
            +mobile()
                position relative
                background #f0f0f0
                margin vw(-10, $mobile) vw(-20, $mobile)
                padding vw(16, $mobile) 0
                font-size vw(60, $mobile)
        &__description
            font-size vw(14, $desktop)
            margin vw(18, $desktop) 0 vw(30, $desktop)
            line-height vw(20, $desktop)
            text-align left
            position relative
            &__opened-text
                display none
            +mobile()
                font-size vw(16, $mobile)
                line-height vw(24, $mobile)
                z-index 103
                position relative
                &__inner
                    position relative
                    z-index 1
                &:before
                    content ""
                    display block
                    position absolute
                    top 0
                    left vw(-20, $mobile)
                    width "calc(100% + %s)" % vw(40, $mobile)
                    height "calc(100% + %s)" % vw(40, $mobile)
                    background linear-gradient(#f0f0f0 50%, rgba(240, 240, 240, 0))
                    display none
        &--opened &__description__not-opened-text
            display none
            animation descriptionNotOpenedText .75s forwards
        &--opened &__description__opened-text
            opacity 0
            display inline
            animation descriptionOpenedText .75s forwards

        &__inner
            margin 0 vw(46, $desktop)
            +mobile()
                margin 0
        &__buttons
            display flex
            align-items center
            white-space nowrap
            .listen
                margin-left vw(25,$desktop)
                +mobile()
                    margin-left 0
            .button
                font-size vw(14, $desktop)
                padding vw(12, $desktop) vw(24, $desktop)
                +mobile()
                    font-size vw(14, $mobile)
                    padding vw(12, $mobile) vw(24, $mobile)
            +mobile()
                margin 0!important
                position relative
                z-index 103
                justify-content space-between
                /*position absolute
                  left 0
                bottom 0
                */
                width 100%

                padding vw(20, $mobile) 0
                /*padding-top vw(140, $mobile)
                background linear-gradient(rgba(240, 240, 240, 0) 30%, #f0f0f0 60%)*/
        &--opened &__buttons
            +mobile()
                display none
        &__read-more
            margin-top vw(20, $desktop)
            width 100%
            +mobile()
                display none
            &__text
                color #aca298
                font-style italic
                font-size vw(10, $desktop)
            &__arrow
                position relative
                height vw(30, $desktop)
                fill #aca298
                animation readMoreArrow 3s infinite

        &__main
            position relative
            z-index 101
            +mobile()
                z-index 103
            &:before
                /*
                content ""
                display block
                background linear-gradient(rgba(240, 240, 240, 0), #f0f0f0)
                position absolute
                left 0
                width 100%
                top vw(-120, $desktop)
                height vw(120, $desktop)
                +mobile()
                    display none
                */
        &__link
            cursor pointer
            text-decoration none
            color #cb993f
            border-bottom 1px dashed #cb993f
        &__paragraph
            font-size vw(13, $desktop)
            line-height 1.5
            position relative
            opacity 1
            transition all .5s
            &--inactive
                opacity 0
            +mobile()
                opacity 1
                transform translateY(0)
                font-size vw(16, $mobile)
                margin-left 0!important
                width "calc(100% - %s)" % vw(40, $mobile)!important
                padding 0 vw(20, $mobile)
            p
                margin vw(12, $desktop) 0
                +mobile()
                    margin vw(12, $mobile) 0
        &__paragraph--inactive.chapter__paragraph--1
            transform translateX(vw(-240, $desktop))
            +mobile()
                transform none
        &__paragraph--inactive.chapter__paragraph--2
            transform translateX(vw(240, $desktop))
            +mobile()
                transform none
        &__paragraph--inactive.chapter__paragraph--3
            transform translateX(vw(-240, $desktop))
            +mobile()
                transform none

        &__picture-container
            overflow hidden
        &__picture
            width 100%
        &__next
            text-align center
            padding vw(170, $desktop) 0 vw(120, $desktop)
            +mobile()
                padding-top 0
                padding-bottom vw(70, $mobile)
            &__button
                margin-top vw(20, $desktop)
                +mobile()
                    margin-top vw(30, $mobile)
        &__next &__headline
            +mobile()
                margin 0
                background none
                padding-top 0
        &__next &__headline
            font-size vw(78, $desktop)
            margin vw(-10, $desktop) 0 0
            +mobile()
                margin 0
                font-size vw(60, $mobile)
        &__next &__number
            +mobile()
                display block
        &.chapter3, &.chapter4, &.chapter5
            .chapter__illustration
                +mobile()
                    background-position left bottom
@keyframes readMoreArrow
    0%
        top 0
    50%
        top vw(20, $desktop)
    100%
        top 0
@keyframes descriptionOpenedText
    0, 49%
        display none
    50%
        opacity 0
        display inline
    100%
        display inline
        opacity 1

@keyframes descriptionNotOpenedText
    0%
        opacity 1
    49%
        opacity 0
        display inline
    50%, 100%
        opacity 0
        display none
</style>
